import d from "./LLMApiService.js";
import { getResizedImageFile as l } from "../utils/image.js";
const w = "minohealth-storage", f = "fra1.digitaloceanspaces.com", g = new RegExp(`^https://${w}\\.${f}/(.+)$`), c = (e) => g.test(e), E = ({ itemUrl: e }) => e.match(/\.([^.]+)$/)?.[1] ?? "";
async function i(e, r, t) {
  try {
    const o = await d(r).getPresignedDownloadUrl(e), s = await (await fetch(o, { signal: t })).arrayBuffer();
    return btoa(String.fromCharCode(...new Uint8Array(s)));
  } catch (o) {
    throw new Error(`Failed to load ${e}`, { cause: o });
  }
}
const $ = ({ objectUrl: e, userToken: r, signal: t }) => {
  if (!c(e)) throw new Error(`Invalid object url ${e}`);
  return i(e, r, t);
}, F = ({ chatImageUrl: e, userToken: r, signal: t }) => c(e) ? i(e, r, t) : Promise.resolve(e), P = ({ thumbnailUrl: e, userToken: r }) => c(e) ? i(e, r) : Promise.resolve(e), C = ({ imageUrl: e, userToken: r }) => c(e) ? i(e, r) : Promise.resolve(e);
async function A({ objectUrl: e, userToken: r }) {
  if (!c(e)) return e;
  try {
    return await d(r).getPresignedDownloadUrl(e);
  } catch (t) {
    throw new Error(`Failed to get presigned URL for ${e}`, { cause: t });
  }
}
async function h(e, r, t, { signal: o } = {}) {
  try {
    const { uploadUrl: a, objectUrl: s } = await d(t).getPresignedUploadUrl(r, e.type);
    return await fetch(a, { method: "PUT", body: e, headers: { "Content-Type": e.type }, signal: o }), s;
  } catch (a) {
    throw new Error(`Failed to upload ${r}`, { cause: a });
  }
}
function m(e, r, t) {
  return h(e, `chat/${r}`, t);
}
async function R(e, r, t = "no_user") {
  try {
    const o = await l(e, 512).catch(() => e);
    if (t === "no_user" || !r)
      return new Promise((s, u) => {
        const n = new FileReader();
        n.onload = () => {
          typeof n.result == "string" ? s(n.result) : u(new Error("Failed to read image"));
        }, n.onerror = () => u(n.error || new Error("Failed to read image")), n.readAsDataURL(o);
      });
    const a = `${t.slice(0, 10)}${p()}.${e.name}`;
    return await m(o, a, r);
  } catch (o) {
    throw new Error("Failed to upload resized image", { cause: o });
  }
}
function p() {
  const e = Math.random();
  return e === 1 ? p() : `${e.toString(16).replace(/^0\./, "")}${Date.now().toString(16)}`;
}
export {
  E as getSpacesItemExtension,
  A as getSpacesPresignedUrl,
  c as isSpacesUrl,
  F as loadChatImageFromSpaces,
  $ as loadObjectFromSpaces,
  P as loadThumbnailFromSpaces,
  C as loadUploadImageFromSpaces,
  R as resizeAndUploadChatImage,
  m as uploadChatFile,
  h as uploadObjectToSpaces
};
